import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "../components/SectionHeading";
import Reveal from "../components/Reveal";
import { ARTICLES } from "../data/articles";

export default function Learn() {
  return (
    <div data-testid="page-learn" className="pt-32 md:pt-40 pb-24">
      <section className="px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <SectionHeading
              overline="Learn"
              title="Skincare science, explained simply."
              subtitle="Plain-language articles based on published research. Nothing on this site is for sale, and no products are recommended for profit."
            />
          </Reveal>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {ARTICLES.map((a, i) => (
              <Reveal key={a.slug} delay={i * 70}>
                <Link
                  to={`/learn/${a.slug}`}
                  data-testid={`article-card-${a.slug}`}
                  className="group bg-white border border-navy/10 rounded-sm overflow-hidden flex flex-col h-full hover-lift"
                >
                  <div className="aspect-[4/3] overflow-hidden bg-navy/5">
                    <img
                      src={a.image}
                      alt={a.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-6 md:p-7 flex flex-col flex-1">
                    <div className="flex items-center gap-3 text-[11px] tracking-[0.22em] uppercase">
                      <span className="text-gold">{a.category}</span>
                      <span className="text-charcoal/40">&middot;</span>
                      <span className="text-charcoal/60">{a.readTime}</span>
                    </div>
                    <h3 className="mt-3 font-heading text-xl md:text-2xl text-navy leading-snug group-hover:text-gold transition-colors">
                      {a.title}
                    </h3>
                    <p className="mt-3 text-sm text-charcoal/75 leading-relaxed flex-1">{a.excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-navy group-hover:text-gold">
                      Read article <ArrowUpRight size={14} />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
